import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PhysicianActions } from '../../actions/constant';
import physicianService, {
  PhysicianDTO,
} from 'src/services/apiServices/physician-service/physician-service';

const {
  REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
} = PhysicianActions;

interface GetPhysicianDocumentsAction {
  type: typeof REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS;
  physicianId: string;
  physicianDto: PhysicianDTO;
}

function* getPhysicianCompletedDocuments(action: GetPhysicianDocumentsAction): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS });
    const response = yield call(
      physicianService.getAllPhysicianDocuments,
      action.physicianId,
      action.physicianDto
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS, payload: error });
  }
}

function* getPhysicianCompletedDocumentsSaga() {
  yield takeEvery(REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS, getPhysicianCompletedDocuments);
}

export default getPhysicianCompletedDocumentsSaga;
